import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackPageView } from '../analytics';

function usePageTracking() {
  const location = useLocation();

  useEffect(() => {
    // One page view per route change (GA4 + GTM dataLayer + Meta Pixel on SPA navigations)
    trackPageView(location.pathname + location.search, document.title);
  }, [location.pathname, location.search]);
}

export default usePageTracking;
